<script>
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;
  let hubspotWebhookLogsInstance = null;

  const mountHubspotWebhookLogs = async () => {
    const module = await import("App/hubspotWebhookLogs");
    const HubspotWebhookLogs = module.default;

    if (el1) {
      hubspotWebhookLogsInstance = mountFederatedSvelteComponent(
        hubspotWebhookLogsInstance,
        HubspotWebhookLogs,
        { target: el1 }
      );
    }
  };

  void mountHubspotWebhookLogs();

  onDestroy(() => {
    hubspotWebhookLogsInstance = destroySvelteComponentInstance(hubspotWebhookLogsInstance);
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
  </div>
</PageContainer>
